import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "16px",
      alignSelf: "stretch",
    },
    title: {
      color: "#101828",
      fontSize: "24px",
      fontWeight: "700",
      lineHeight: "26.4px",
    },
    innerContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "16px",
      width: "100%",
    },
    accounts: {
      alignSelf: "flex-center",
      color: "#101828",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
    },
    accountsNum: {
      color: "#8935CC",
    },
    filters: {
      display: "flex",
      gap: "16px",
      alignItems: "center",
    },
    leftColumnWrapper: {
      display: "flex",
      flexDirection: "column",
      flex: 4,
      gap: "8px",
    },
    columnsWrapper: { display: "flex", width: "100%", gap: "8px" },
    loadingAndErrorWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "300px",
      width: "100%",
    },
  })();
};
